import { invalidRenteredPasswordMessageMap } from './errorDictionary';
import { isValidReEnteredPassword } from '../../utils/fieldValidators';
import useValidators from './useValidators';
function useValidReEnteredPassword() {
    const errorMessageMap = [invalidRenteredPasswordMessageMap];
    const validators = [isValidReEnteredPassword];
    return useValidators(errorMessageMap, validators);
}
export default useValidReEnteredPassword;
